import React, { useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Modal, ModalBody } from "reactstrap";
import { getAloricaIncentiveCardsDetails } from "../../../store/actions";

const AgentScheduleModal = ({ clickedRow, showModal, toggleModal }) => {
  const dispatch = useDispatch();
  const { activeOrganizationInfo, incentiveCardsInfo, isFetching } =
    useSelector(
      ({
        get_active_organization_detail: { data: activeOrganizationData },
        get_alorica_incentive_cards_details: {
          data: agentInsentiveData,
          isFetching,
        },
      }) => {
        return {
          activeOrganizationInfo: activeOrganizationData || {},
          incentiveCardsInfo: agentInsentiveData,
          isFetching: isFetching,
        };
      },
      shallowEqual,
    );
  const closeBtn = (
    <div
      className="links_right"
      style={{ position: "absolute", top: "15px", right: "15px" }}
    >
      <button
        className="modal_close bg-transparent"
        onClick={toggleModal}
        type="button"
      >
        <img src="/images/cross.svg" />
      </button>
    </div>
  );

  useEffect(() => {
    dispatch(
      getAloricaIncentiveCardsDetails({
        companyguid: activeOrganizationInfo?.Companyguid,
        organization: activeOrganizationInfo?.Organization,
        program: activeOrganizationInfo?.Program,
        employeenumber: activeOrganizationInfo?.Employeeid,
        type: "IncentivePopup",
      }),
    );
  }, [dispatch]);

  return (
    <Modal
      isOpen={showModal}
      toggle={toggleModal}
      backdrop={true}
      keyboard={true}
      external={closeBtn}
      id="uhc_incentive_modal"
    >
      <ModalBody style={{ padding: 0 }}>
        <div className="row">
          <div className="col-md-12">
            {/* ===== Header strip (TempData["primaryprogram"]) ===== */}
            <div className="uhc_header">{activeOrganizationInfo?.Program}</div>
            {/* ===== Dynamic Incentive Table ===== */}
            {incentiveCardsInfo?.incentivesTileMonthwiseDisplay?.length > 0 && (
              <div className="uhc_table">
                <table className="table table-bordered" style={{ margin: 0 }}>
                  <thead>
                    <tr>
                      {Object.keys(
                        incentiveCardsInfo.incentivesTileMonthwiseDisplay[0],
                      ).map((columnName) => (
                        <th key={columnName} style={{ textAlign: "center" }}>
                          {columnName}
                        </th>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {incentiveCardsInfo.incentivesTileMonthwiseDisplay.map(
                      (rowData, rowIndex) => (
                        <tr key={rowIndex}>
                          {Object.values(rowData).map((value, colIndex) => (
                            <td key={colIndex} style={{ textAlign: "center" }}>
                              {value === null || value === "{}" ? "" : value}
                            </td>
                          ))}
                        </tr>
                      ),
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};
export default AgentScheduleModal;
